/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPointsCreateReqVo
 */
export interface UserPointsCreateReqVo {
    /**
     * 用户 ID
     * @type {number}
     * @memberof UserPointsCreateReqVo
     */
    userId: number;
    /**
     * 积分数量
     * @type {number}
     * @memberof UserPointsCreateReqVo
     */
    amount: number;
    /**
     * 冻结金额
     * @type {number}
     * @memberof UserPointsCreateReqVo
     */
    freezeAmount: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UserPointsCreateReqVo
     */
    enable: number;
}

/**
 * Check if a given object implements the UserPointsCreateReqVo interface.
 */
export function instanceOfUserPointsCreateReqVo(value: object): value is UserPointsCreateReqVo {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('freezeAmount' in value) || value['freezeAmount'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    return true;
}

export function UserPointsCreateReqVoFromJSON(json: any): UserPointsCreateReqVo {
    return UserPointsCreateReqVoFromJSONTyped(json, false);
}

export function UserPointsCreateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPointsCreateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'amount': json['amount'],
        'freezeAmount': json['freezeAmount'],
        'enable': json['enable'],
    };
}

export function UserPointsCreateReqVoToJSON(json: any): UserPointsCreateReqVo {
    return UserPointsCreateReqVoToJSONTyped(json, false);
}

export function UserPointsCreateReqVoToJSONTyped(value?: UserPointsCreateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'amount': value['amount'],
        'freezeAmount': value['freezeAmount'],
        'enable': value['enable'],
    };
}

